import { AfterViewInit, Component, inject, input, model, output, ViewChild } from '@angular/core';
import { timer } from 'rxjs';
import { MatSelectModule } from '@angular/material/select';
import { FormBuilder, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'pixl-federal-states-combobox',
  standalone: true,
  imports: [
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule
  ],
  templateUrl: './federal-states-combobox.component.html',
  styleUrl: './federal-states-combobox.component.scss'
})
export class FederalStatesComboboxComponent implements AfterViewInit {
  @ViewChild('federal_states') federal_states!: HTMLSelectElement;

  FEDERAL_STATES = [
    'Baden-Württemberg',
    'Bayern',
    'Berlin',
    'Brandenburg',
    'Bremen',
    'Hamburg',
    'Hessen',
    'Mecklenburg-Vorpommern',
    'Niedersachsen',
    'Nordrhein-Westfalen',
    'Rheinland-Pfalz',
    'Saarland',
    'Sachsen',
    'Sachsen-Anhalt',
    'Schleswig-Holstein',
    'Thüringen',
    'Bundesweit',
    'Berufliche Bildung',
    'Österreich',
    'Schweiz',
  ];

  required = input<boolean>(false);
  initValue = model<string[]>([]);
  initValueChange = output<string[]>();
  fb = inject(FormBuilder);
  isEmpty = false;
  protected FederalStatesControl: FormControl = new FormControl(null);

  public ngAfterViewInit(): void {
    timer(0).subscribe(() => {
      this.FederalStatesControl.setValue(this.initValue());
    });
  }

  public onChangeEvent(ev: string[]): void {
    if (!ev) {
      this.isEmpty = true;
    }
    this.initValueChange.emit(ev);
  }
}
